import React from 'react'
import { FloodList } from "../helper/MenuList";
import MenuItem from '../components/MenuItem';
import '../styles/Flood.css'

function Cold() {
  return (
    <div className='flood'>
      <h1 className='floodTitle'>Torrential Rain</h1>
      <div className='floodList'>
        {FloodList.map((cardItem, key) => {
            return (
            <MenuItem 
                key={key}
                image={cardItem.image} 
                name={cardItem.name} 
                desc={cardItem.desc} />
            )
        })}
      </div>
    </div>
  )
}

export default Cold
